import { Either } from "../../core/types/Either";
import { User } from "../entity/User";

export abstract class UserRepository {
  abstract login(
    email: string,
    password: string
  ): Promise<Either<Error, string>>;

  abstract getUser(): Promise<Either<Error, User>>;

  abstract getUserByToken(token: string): Promise<Either<Error, User>>;

  abstract logout(): Promise<Either<Error, void>>;

  /**
   * PPI-1848: remaining TTL on the stored credential, so the renewal clock
   * knows when the auth service is willing to rotate it. Never used to decide
   * client-side logout — that is idle time, which lives in SessionRepository.
   */
  abstract getTokenRemainingSeconds(): Promise<Either<Error, number>>;

  /**
   * PPI-1848: refreshes the stored credential without producing a User.
   * Distinct from getUser precisely because it must NOT drive React state.
   */
  abstract renewSession(): Promise<Either<Error, void>>;
}
